import validate from "/root/injective/injective-helix/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@25.2.0_@vue+compiler-sfc@3.5.26_bufferutil_ddd4656572db2d8a2b1b53ea2b21717a/node_modules/nuxt/dist/pages/runtime/validate.js";
import dev_45mode_45global from "/root/injective/injective-helix/app/middleware/dev-mode.global.ts";
import maintenance_45global from "/root/injective/injective-helix/app/middleware/maintenance.global.ts";
import route_45global from "/root/injective/injective-helix/app/middleware/route.global.ts";
import manifest_45route_45rule from "/root/injective/injective-helix/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@25.2.0_@vue+compiler-sfc@3.5.26_bufferutil_ddd4656572db2d8a2b1b53ea2b21717a/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  dev_45mode_45global,
  maintenance_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  connected: () => import("/root/injective/injective-helix/app/middleware/connected.ts"),
  "mega-vault-whitelisted": () => import("/root/injective/injective-helix/app/middleware/mega-vault-whitelisted.ts"),
  swap: () => import("/root/injective/injective-helix/app/middleware/swap.ts")
}